import React from 'react';
import PropTypes from 'prop-types';
import ZoomSlider from '@Containers/Zoom/ZoomSlider';
import HeatmapButton from '../HeatmapButton';
import GridListViewButton from '../GridListViewButton';

export default function ResultToolbarRightControls(props) {
  const { context, zoomOnMouseEnterHandler, zoomOnMouseLeaveHandler } = props;
  return (
    <section className="result-toolbar-bottom-right-controls">
      <ZoomSlider
        {...props}
        onMouseEnterHandler={zoomOnMouseEnterHandler}
        onMouseLeaveHandler={zoomOnMouseLeaveHandler}
        className="u-els-margin-right-1x1o2"
        zoomKey={context}
      />
      <GridListViewButton {...props} />
      <HeatmapButton {...props} />
    </section>
  );
}

ResultToolbarRightControls.propTypes = {
  context: PropTypes.string.isRequired,
  zoomOnMouseEnterHandler: PropTypes.func.isRequired,
  zoomOnMouseLeaveHandler: PropTypes.func.isRequired,
};
